import styled from "styled-components";
import { breakpoints } from "styles";
import { Container } from "styles/common/container";

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SocialContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
`;

export const DownloadCTAContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  @media ${breakpoints.tablet} {
    margin-top: 40px;
  }
`;

export const DownloadText = styled.div`
  padding-top: 40px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["lg"]};
  }
`;

export const Socials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  @media ${breakpoints.mobile} {
    justify-content: center;
    align-items: center;
    width: 300px;
  }
`;

export const Heading = styled.h2`
  font-family: Poppins, sans-serif;
  font-weight: 700;
  line-height: 42px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: black;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  margin: 16px;
  text-wrap: balance;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    line-height: 42px;
    text-align: center;
  }
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes.sxl};
    line-height: 32px;
  }

  span {
    color: ${({ theme }) => theme.colors.brand[500]};
  }
`;

export const ImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${breakpoints.mobile} {
    height: 100%;
    width: 85%;
  }
`;
